import React from 'react';

interface DashboardOverlayShellProps {
    isDashboardOpen: boolean;
    overlayVisible:boolean;
    children: React.ReactNode;
}

export const DashboardOverlayShell: React.FC<DashboardOverlayShellProps> = ({
    isDashboardOpen,
    overlayVisible,
    children,
}) => {
    return (
        <div
            className={`editor-dashboard-overlay${isDashboardOpen ? ' editor-dashboard-overlay--open' : ''}`}
            style={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9000,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                overflowY: overlayVisible? 'hidden':'auto',
            }}
        >
            {children}
        </div>
    );
};
